import React from 'react';
import '../../scss/MaterialRequestScanner.scss';
import { MaterialRequestScannerApp } from './Functionality/MaterialRequestScannerApp';
import ScannerCard from './Subcomponents/ScannerCard';
import ScannerStatusCard from './Subcomponents/ScannerStatusCard';
import FullPageLoader from '../../utils/FullPageLoader';
import HeadTittle from '../../components/HeadTittle';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const MaterialRequestScanner = () => {
    const {
        t,
        status,
        currentAction,
        showSpinner,
        goBack,
    } = MaterialRequestScannerApp();

    return (
        <>
            {showSpinner && <FullPageLoader />}
            <div className='scanner-background'>
                <div className='scanner-header'>
                    <HeadTittle name={'material_request_scanner'} onBack={goBack}>
                        <ScannerStatusCard t={t} currentAction={currentAction} />
                    </HeadTittle>
                </div>

                <div className='scanner-content'>
                    <ScannerCard
                        t={t}
                        status={status}
                    />
                </div>
            </div>
        </>
    );
};

export default MaterialRequestScanner;
